/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import AppBanner from "./AppBanner";

export default AppBanner;
